import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { MatCard } from "@angular/material/card";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: "app-not-found",
    templateUrl: "./not-found.component.html",
    styleUrls: ["./not-found.component.scss"],
    imports: [MatCard, MatButton, MatIcon]
})
export class NotFoundComponent {
    notFound = true;

    constructor(private readonly router: Router) {}

    async goToChat(): Promise<void> {
        await this.router.navigate(["/"]);
    }
}
